import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import StoreService from "../services/StoresService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useStoreSubmit = (id) => {

    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

    const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

    const [imageUrl, setImageUrl] = useState("");
    const [isModal, setIsModal] = useState(false);
    const [isViewModal, setIsViewModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [viewData, setviewData] = useState([]);


    // add and update Store details
    const onSubmit = async (data) => {

        setPageLoading(true);
        try {
            data.logo = imageUrl;
            const response = id ? await StoreService.UpdateStoreById(id, data) : await StoreService.addStore(data);
            if (response?.success) {
                notifySuccess(response.message);
                setIsModal(false);
                setDataUpdate(!dataUpdate);
            }
            else {
                notifyError(response.message);
            }
        } catch (error) {
            console.error(error);
            notifyError(error?.response?.data?.message || error.message);
        } finally {
            setPageLoading(false);
        }
    };

    //  delete Store by id 
    const handleDeleteStore = async (id) => {
        try {
            const response = await StoreService.deleteStoreById(id);
            if (response.success) {
                notifySuccess(response?.message);
                setDataUpdate(!dataUpdate);
            }
            else {
                notifyError(response?.message);
            }
            setIsDeleteModal(false);
        }
        catch (error) {
            console.error("error", error);
            notifyError("Something want wrong !");
            setIsDeleteModal(false);
        }
    }

    useEffect(() => {
        reset();
        setImageUrl("");
        if (id) {
            (async () => {
                try {
                    const res = await StoreService.getStoreById(id);
                    const data = res?.data;
                    if (res?.success) {
                        setviewData(data);
                        setValue("name", data.name);
                        setValue("domain", data.domain);
                        setValue("email", data.email);
                        setValue("phone", data.phone);
                        setValue("address", data.address);
                        setValue("zipcode", data.zipcode);
                        setValue("country", data.country);
                        setImageUrl(data?.logo || "");
                    }
                } catch (error) {
                    console.error("Error fetching store data:", error);
                }
            })();
        }
    }, [isModal, id]);

    return {
        register,
        handleSubmit,
        setValue,
        errors,
        onSubmit,
        handleDeleteStore,
        pageLoading,
        imageUrl,
        setImageUrl,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        viewData,

    }
}

export default useStoreSubmit;